import { render, staticRenderFns } from "./CmgFeedbackModal.vue?vue&type=template&id=6757a60f&scoped=true&lang=pug"
import script from "./cmg-feedback-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-feedback-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFeedbackModal.vue?vue&type=style&index=0&id=6757a60f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757a60f",
  null
  
)

export default component.exports